'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    notificationTrigger: 'COMPLETION',
    notificationRecipient: 'USERS_AT_ORGANISATION_UNIT'
};
//# sourceMappingURL=programNotificationTemplate.js.map


//////////////////
// WEBPACK FOOTER
// ./~/d2/lib/model/config/model-defaults/programNotificationTemplate.js
// module id = 383
// module chunks = 0